export default __webpack_public_path__ + "images/bb66f6415adc2720bcee625024e8f43d-mysticism.webp";